export default {"src":"/_next/static/media/lsm-tutorial-connect-wallet.e0a9dc31.svg","height":249,"width":188,"blurWidth":0,"blurHeight":0};